// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__w9LYB","cover":"index_cover__LgJ7P","brief":"index_brief__qN48s"};